import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { HttpService } from './httpService';
import { ConfigService } from './configService';
import { DocumentModel } from '../components/documents-page/documents.model';

@Injectable()
export class DocumentsService {
    private baseUrl: string;

    constructor(private http: HttpService,
                private config: ConfigService) {
        this.baseUrl = this.config.get('apiUrl') + '/v1';
    }

    public getDocuments(linkTo: string, linkToPK: string): Observable<DocumentModel[]> {
        return this.http.get(`${this.baseUrl}/documents/${linkTo}/${linkToPK}`);
    }

    public getDocumentContent(docId: number): Observable<any> {
        return this.http.get(this.baseUrl + `/document/${docId}/content`, 'arraybuffer');
    }

    public getEmail(id: any): Observable<any> {
        return this.http.get(this.baseUrl + '/email/' + id);
    }

    public getIconForDocument(
        fileLocation: string,
        subTable: string,
        isDraft: boolean = false
    ) {
        if (this.isImage(fileLocation)) {
            return 'jetfileicon jetfileicon-image-document';
        }

        if (this.isPdf(fileLocation)) {
            return 'jetfileicon jetfileicon-pdf';
        }

        if (this.isXLS(fileLocation)) {
            return 'jetfileicon jetfileicon-office-excel';
        }

        if (this.isHtml(fileLocation)) {
            return 'jetfileicon jetfileicon-email';
        }

        if (this.isVideo(fileLocation)) {
            return 'jetfileicon jetfileicon-video';
        }

        if (this.isPpt(fileLocation)) {
            return 'jetfileicon jetfileicon-office-powerpoint';
        }

        if (this.isRtf(fileLocation) || this.isDocument(fileLocation)) {
            return 'jetfileicon jetfileicon-office-word';
        }

        if (this.isTxt(fileLocation)) {
            return 'jetfileicon jetfileicon-text-document';
        }

        if (isDraft) {
            return 'jetfileicon jetfileicon-note';
        }

        subTable = (subTable || '').toUpperCase();
        if (subTable === 'LETTERS' || subTable === 'EMAILS') {
            return 'jetfileicon jetfileicon-email';
        }
        return 'jetfileicon jetfileicon-new disabled';
    }

    public isPdf(fileName: string): boolean {
        return !!fileName && fileName.toUpperCase().indexOf('.pdf'.toUpperCase()) > 0;
    }

    public isXLS(fileName: string): boolean {
        return (
            !!fileName &&
            (fileName.toUpperCase().indexOf('.xls'.toUpperCase()) > 0 ||
                fileName.toUpperCase().indexOf('.xlsx'.toUpperCase()) > 0 ||
                fileName.toUpperCase().indexOf('.csv'.toUpperCase()) > 0)
        );
    }

    public isVideo(fileName: string): boolean {
        return (
            !!fileName &&
            (fileName.toUpperCase().indexOf('.mov'.toUpperCase()) > 0 ||
                fileName.toUpperCase().indexOf('.avi'.toUpperCase()) > 0 ||
                fileName.toUpperCase().indexOf('.mpg'.toUpperCase()) > 0 ||
                fileName.toUpperCase().indexOf('.mpeg'.toUpperCase()) > 0 ||
                fileName.toUpperCase().indexOf('.mpv'.toUpperCase()) > 0 ||
                fileName.toUpperCase().indexOf('.mkv'.toUpperCase()) > 0 ||
                fileName.toUpperCase().indexOf('.flv'.toUpperCase()) > 0)
        );
    }

    public isPpt(fileName: string): boolean {
        return (
            !!fileName &&
            (fileName.toUpperCase().indexOf('.ppt'.toUpperCase()) > 0 ||
                fileName.toUpperCase().indexOf('.pptx'.toUpperCase()) > 0)
        );
    }

    public isDocument(fileName: string): boolean {
        if (!fileName) {
            return false;
        }

        if (
            fileName.toUpperCase().indexOf('.pdf'.toUpperCase()) > 0 ||
            fileName.toUpperCase().indexOf('.xls'.toUpperCase()) > 0 ||
            fileName.toUpperCase().indexOf('.xlsx'.toUpperCase()) > 0 ||
            fileName.toUpperCase().indexOf('.doc'.toUpperCase()) > 0 ||
            fileName.toUpperCase().indexOf('.docx'.toUpperCase()) > 0 ||
            fileName.toUpperCase().indexOf('.rtf'.toUpperCase()) > 0 ||
            fileName.toUpperCase().indexOf('.csv'.toUpperCase()) > 0
        ) {
            return true;
        }
        return false;
    }

    public isImage(fileName: string): boolean {
        if (!fileName) {
            return false;
        }

        if (
            fileName.toUpperCase().indexOf('.jpg'.toUpperCase()) > 0 ||
            fileName.toUpperCase().indexOf('.jpeg'.toUpperCase()) > 0 ||
            fileName.toUpperCase().indexOf('.bmp'.toUpperCase()) > 0 ||
            fileName.toUpperCase().indexOf('.ico'.toUpperCase()) > 0 ||
            fileName.toUpperCase().indexOf('.emf'.toUpperCase()) > 0 ||
            fileName.toUpperCase().indexOf('.png'.toUpperCase()) > 0 ||
            fileName.toUpperCase().indexOf('.wmf'.toUpperCase()) > 0
        ) {
            return true;
        }
        return false;
    }

    public isHtml(fileName: string): boolean {
        if (!fileName) {
            return false;
        }

        if (fileName.toUpperCase().indexOf('.htm'.toUpperCase()) > 0) {
            return true;
        }
        return false;
    }

    public isRtf(fileName: string): boolean {
        if (!fileName) {
            return false;
        }

        if (fileName.toUpperCase().indexOf('.rtf'.toUpperCase()) > 0) {
            return true;
        }
        return false;
    }

    public isTxt(fileName: string): boolean {
        if (!fileName) {
            return false;
        }

        if (fileName.toUpperCase().indexOf('.txt'.toUpperCase()) > 0) {
            return true;
        }
        return false;
    }
}